export function b64ToFloat32Array(data: string) {
  let p = 0;
  const result = new Float32Array(data.length / Float32Array.BYTES_PER_ELEMENT);
  const dView = new DataView(new ArrayBuffer(Float32Array.BYTES_PER_ELEMENT));
  for (let i = 0; i < data.length / Float32Array.BYTES_PER_ELEMENT; i++) {
    p = i * 4;
    for (let j = 0; j < Float32Array.BYTES_PER_ELEMENT; ++j) {
      dView.setUint8(j, data.charCodeAt(p + j));
    }
    result[i] = dView.getFloat32(0, true);
  }
  return result;
}
